<div class="min-h-screen bg-slate-100">

  <!-- ── Header do site — badge de marca + navegação ─────────── -->
  <header class="bg-slate-50 border-b border-slate-200 border-t-4 border-t-slate-900">
    <div class="h-14 px-4 w-full flex items-center gap-6">
      <span class="inline-flex items-center gap-1.5 bg-red-600 text-white text-sm font-bold italic px-3 py-1.5 rounded-lg shrink-0">
        <svg class="w-4 h-4" viewBox="0 0 24 24" fill="currentColor"><rect x="3" y="3" width="18" height="18" rx="4"/></svg>
        lojas MM
      </span>

      <nav class="flex gap-1 text-sm">
        <a routerLink="/gestao" routerLinkActive="bg-blue-100 text-blue-700"
           class="px-3 py-2 rounded-lg font-medium text-slate-600 hover:bg-slate-100">
          Recebimento
        </a>
        <a routerLink="/etiquetas" routerLinkActive="bg-blue-100 text-blue-700"
           class="px-3 py-2 rounded-lg font-medium text-slate-600 hover:bg-slate-100">
          Ver Etiquetas
        </a>
        <a routerLink="/acompanhamento" routerLinkActive="bg-blue-100 text-blue-700"
           class="px-3 py-2 rounded-lg font-medium text-slate-600 hover:bg-slate-100">
          Acompanhamento
        </a>
      </nav>
    </div>
  </header>

  <router-outlet />

</div>
